<div class="max-w-2xl mx-auto">
  <h1 class="text-2xl font-semibold text-gray-900 mb-6">{{ 'settings.title' | translate }}</h1>

  <div class="flex flex-col gap-3">
    @for (entry of entries; track entry.route) {
      <cmi-settings-link [entry]="entry" />
    }
  </div>

  <div class="mt-6 flex items-center justify-center gap-2 text-sm text-gray-500">
    <span>{{ 'settings.version' | translate }}: {{ buildVersion || '-' }}</span>
    <button
      type="button"
      class="inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
      aria-label="{{ 'settings.copyVersion' | translate }}"
      title="{{ 'settings.copyVersion' | translate }}"
      (click)="copyBuildVersion()">
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    </button>
    @if (copyFeedback() === 'copied') {
      <span class="text-xs text-green-700">{{ 'settings.copySucceeded' | translate }}</span>
    }
    @if (copyFeedback() === 'failed') {
      <span class="text-xs text-red-700">{{ 'settings.copyFailed' | translate }}</span>
    }
  </div>
</div>
